<template>
  <v-row  v-on:click="toggleCard()">

      <transition name="flip">
        <v-col v-bind:key="sponsor.flipped">
          <section v-if="!sponsor.flipped" class="card card-front">
            <section class="section-image">
              <v-img
                v-bind:src="url_logo"
                class="white--text align-end text-truncate"
                height="90px"
                contain
              >
              </v-img>
            </section>
            
            <section class="section-flag">
              <v-img
                v-bind:src="url_flag"
                class="img-flag"
                fixed
              >
              </v-img>
            </section>

            <section class="section-title pl-2 pr-2">
              <h4 style="font-weight: 300;">{{ sponsor.name }}</h4>
            </section>

            <section class="section-social">
              <a v-if="sponsor.web" :href="sponsor.web" target="_blank">
                <v-icon>
                  mdi-web
                </v-icon>
              </a>

              <a v-if="sponsor.linkedin" :href="sponsor.linkedin" target="_blank">
                <v-icon>
                  mdi-linkedin
                </v-icon>
              </a>
              
              <a v-if="sponsor.facebook" :href="sponsor.facebook" target="_blank">
                <v-icon>
                  mdi-facebook
                </v-icon>
              </a>
              
              <a v-if="sponsor.instagram" :href="sponsor.instagram" target="_blank">
                <v-icon>
                  mdi-instagram
                </v-icon>
              </a>

              <a v-if="sponsor.twitter" :href="sponsor.twitter" target="_blank">
                <v-icon>
                  mdi-twitter
                </v-icon>
              </a>

              <a v-if="sponsor.youtube" :href="sponsor.youtube" target="_blank">
                <v-icon>
                  mdi-youtube
                </v-icon>
              </a>

              <a v-if="sponsor.whatsapp" :href="sponsor.whatsapp" target="_blank">
                <v-icon>
                  mdi-whatsapp
                </v-icon>
              </a>

              <a v-if="sponsor.email" :href="'mailto:'+sponsor.email" target="_blank">
                <v-icon>
                  mdi-email
                </v-icon>
              </a>
            </section>
            
          </section>

          <section v-if="sponsor.flipped" class="card card-back overflow-auto">
            <p class="text--secondary card-description te">
              {{ sponsor.description }}
            </p>
          </section>  
        </v-col>
      </transition>
    
  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardSponsor',
    props:['sponsor'],

    data: () => ({
      show_card:false,
      loading:false,
      flipped: false,
      newFront: '',
      newBack: '',
      error: false,

      url_logo:null,
      url_flag:null,
      base_url: null
    }),

    methods:{    
      createURL(){
        this.url_logo = this.base_url + this.sponsor.logo
        this.url_flag = this.base_url + this.sponsor.country.flag
        this.show_card = true
      },

      toggleCard: function() {
        this.sponsor.flipped = !this.sponsor.flipped;
      }
    },
    created() {
      this.base_url = APP_URL
      this.createURL()
    }
  }
</script>

<style type='text/css' scoped>
ul {
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
}

li {
  list-style-type: none;
  padding: 10px 10px;
  transition: all 0.3s ease;
}

.container {
  max-width: 100%;
  padding: 2em;
}

.card {
  width: auto;
  will-change: transform;
  outline: 1px solid #E0E0E0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 230px;
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 8px;
  line-height: 27px;
  position: relative;
  color: #000000;
  box-shadow: 0 0 15px rgb(0 0 0 / 0.2);
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.card-back {
  margin: auto; /* Centra el contenido verticalmente */
  text-align: center; /* Centra el contenido horizontalmente */
  font-weight: 400;
  font-size: 13px;
  padding: 25px;
}
.card-description{
  line-height: 1.5; 
  justify-content: center;
  align-items: center;
}

.img-flag{
  height: auto;
  max-width: 30px;
}
.section-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.section-flag {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.section-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.section-social {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

li:hover{
  transform: scale(1.02);
}

.flip-enter-active {
  transition: all .9s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter, .flip-leave {
  transform: rotateY(180deg);
  opacity: 0;

}

/* Form */
.flashcard-form{
  position: relative;
}


label{
  font-weight: 400;
  color: #333;
  margin-right: 10px;
}

input{
  border-radius: 5px;
  border: 2px solid #eaeaea;
  padding: 10px;
  outline: none;
}

button{
  border-radius: 5px;
  border: 1px solid #87cb84;
  background-color: #87cb84;
  padding: 8px 15px;
  outline: none;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover{
  background-color: #70a66f;
}

.error{
  margin-top: 10px;
  display: block;
  color: #e44e42;
  font-weight: 600;
}
</style>